exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".buddyHeader-8df66{display:flex;justify-content:space-between;width:100%}.buddyHeader-8df66 .title-1b5d8{margin-bottom:12px;font-size:20px;font-weight:600;line-height:28px;color:#262626}.buddyHeader-8df66 .actionButtons-0ecad{display:flex;gap:2px}", ""]);

// Exports
exports.locals = {
	"buddyHeader": "buddyHeader-8df66",
	"title": "title-1b5d8",
	"actionButtons": "actionButtons-0ecad"
};